import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { toCents } from "@/utils/numberUtils";

export class UpdateUserHasQualificationAccountingDto {
  @Transform(({ value }) => (value != null ? toCents(value) : value))
  @Expose()
  cost?: number;

  @Transform(({ value }) => (value != null ? toCents(value) : value))
  @Expose()
  internalCost?: number;

  @Expose()
  invoiceNumber?: string;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : null))
  @Expose()
  invoiceDate?: Date | null;

  @Expose()
  supplierId?: string;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : null))
  @Expose()
  paymentDate?: Date | null;

  @Expose()
  subsidized?: boolean;

  @Transform(({ value }) => (value != null ? toCents(value) : value))
  @Expose()
  subsidyAmount?: number;

  @Transform(({ value }) => (value ? parseAppDate(value, true) : null))
  @Expose()
  subsidyMonth?: Date | null;
}
